export default __webpack_public_path__ + "static/media/package4.1b09bd0d.png";